import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../../constants/constants';

export const componentKey = "STATE_FILING/SINGLE_STATE_FILING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setStateFilingAmount: (state, action) => {
            state.stateFilingAmount = action.payload;
        }
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY },
        stateFilingAmount: {},
    }
})

export const { setLoadingState, setStateFilingAmount } = actions; 
